import React from 'react'
import { t } from '@lingui/core/macro'
import { getCountryNames } from '../../types/Country'
import FormSelect, { FormSelectItem } from './FormSelect'

interface CountrySelectProps {
    label: string
    value: string
    onChange: (value: string) => void
    errorMessage?: string
}

const CountrySelect = ({ label, value, onChange, errorMessage }: CountrySelectProps) => {
    return <FormSelect
        label={label}
        value={value}
        items={getCountryNames().map(countryName => ({ value: countryName.name, name: countryName.country })) as FormSelectItem[]}
        placeholder={t`Выберите страну`}
        searchPlaceholder={t`Поиск по названию или коду...`}
        onChange={onChange}
        errorMessage={errorMessage}
    />
}

export default CountrySelect
